import { EUnsubscribeReasonsStep, EUnsubscribeStep } from 'common-types';
import { StateCreator } from 'zustand';

import { StoreType, TUnsubscribeStore } from './types';

export const unsubscribeSlice: StateCreator<StoreType, [], [], TUnsubscribeStore> = (set, get) => ({
  unsubscribeData: {
    activeStep: EUnsubscribeStep.ARE_YOU_SURE,
    unsubscribeStep: EUnsubscribeReasonsStep.REASON,
    subReasons: [],
    activeReason: null,
    isError: false,
  },
  setActiveStep: (activeStep: EUnsubscribeStep): void => {
    set({
      unsubscribeData: {
        ...get().unsubscribeData,
        activeStep,
      },
    });
  },

  setUnsubscribeStep: (unsubscribeStep): void => {
    set({
      unsubscribeData: {
        ...get().unsubscribeData,
        unsubscribeStep,
      },
    });
  },
  changeActiveReason: (reason): void => {
    set({
      unsubscribeData: {
        ...get().unsubscribeData,
        activeReason: reason,
      },
    });
  },
  setSubReasons: (subReason) =>
    set((state) => {
      const exists = state.unsubscribeData.subReasons.includes(subReason);

      return {
        unsubscribeData: {
          ...state.unsubscribeData,
          subReasons: exists
            ? state.unsubscribeData.subReasons.filter((sr) => sr !== subReason)
            : [...state.unsubscribeData.subReasons, subReason],
        },
      };
    }),
  clearSubReasons: (): void => {
    set({
      unsubscribeData: {
        ...get().unsubscribeData,
        subReasons: [],
      },
    });
  },
  openErrorModal: (): void => {
    set({
      unsubscribeData: {
        ...get().unsubscribeData,
        isError: true,
      },
    });
  },
  clearUnsubscribeData: (): void => {
    set({
      unsubscribeData: {
        activeStep: EUnsubscribeStep.ARE_YOU_SURE,
        unsubscribeStep: EUnsubscribeReasonsStep.REASON,
        subReasons: [],
        activeReason: null,
        isError: false,
      },
    });
  },
});
